import styled from 'styled-components';
import { Dimensions } from '@99designs/browser';

interface ScrollPaneProps {
    scaledImageSize: Dimensions;
    viewSize: Dimensions;
}

// A scrollable viewport that calculates whether to enable/disable scrollbars
const ScrollPane = styled.div<ScrollPaneProps>`
    position: absolute;
    left: 0;
    top: 0;
    width: 100%;
    height: 100%;
    margin: 0 0;
    border: none;

    overflow-x: ${({ scaledImageSize, viewSize }) =>
        scaledImageSize.width > viewSize.width ? 'scroll' : 'hidden'};
    overflow-y: ${({ scaledImageSize, viewSize }) =>
        scaledImageSize.height > viewSize.height ? 'scroll' : 'hidden'};
`;

export default ScrollPane;
